const linkedinProfile = [
    { attribute: 'class', childLocation: 0, element: 'pv-top-card--experience-list-item' }, // Contact Page - Contact Experience (Lusha Contacts)
    { attribute: 'id', element: 'experience-section' }, // Contact Page - Contact Experience (Lusha Contacts)
    { attribute: 'class', element: 'top-card__right-column-link', childLocation: 0 }, // Public Contact Page - Contact Information (Lusha Contacts)
    { attribute: 'class', element: 'experience pp-section', childLocation: 0 }, // Public Contact Page - Contact Experience (Lusha Contacts)
    { attribute: 'class', element: 'pvs-entity__image' }, // Contact Page - Contact Experience (Lusha Contacts) (LinkedinV5) (16.03.2022)
];
const linkedinBulk = [
    { attribute: 'class', element: 'search-results-container' }, // Search People Page - Results container (Bulk Enrich)
];
const linkedinCompany = [
    { attribute: 'class', element: 'org-top-card artdeco-card' }, // Company page
];
export const LINKEDIN_LEGACY_INDICATORS_BY_CONTEXT_TYPE = {
    profile: linkedinProfile,
    bulk: linkedinBulk,
    company: linkedinCompany,
    unknown: [...linkedinProfile, ...linkedinBulk, ...linkedinCompany],
};
